module.exports = __webpack_public_path__ + "img/vignettes-asso_0004_la-quinzaine-en-action.cc1e42d6.jpg";